import {
  Box,
  Button,
  Grid,
  Group,
  Menu,
  NumberInput,
  ScrollArea,
  Table,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import cx from "clsx";
import { useEffect, useState } from "react";
import { repositoryDelivery } from "../../../../../_base/_const/_constVar";
import { sky_blue } from "../../../../../const/variables";
import { MessageResponse } from "../../../../../model/MessageResponse";
import { tblPromotionItemGiftCommand } from "../../../../../model/TblPromotion";
import classes from "../../../../../Styles/TableScrollArea.module.css";

const ModalItemGiftEditDiscount = ({
  dataEdit,
  editItemDiscount,
}: {
  dataEdit: tblPromotionItemGiftCommand;
  editItemDiscount: (dataSubmit: tblPromotionItemGiftCommand) => void;
}) => {
  const [scrolled, setScrolled] = useState(false);
  const [scrolledView, setScrolledView] = useState(false);

  const [searchGift, setSearchGift] = useDebouncedState<string>("", 300);
  const [dataGift, setDataGift] = useState<any[]>([]);
  const [dataViewGift, setDataViewGift] = useState<any[]>([]);

  const entity = dataEdit;

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      quantityMax: (value, values) => {
        if (value && values.quantityMin && value < values.quantityMin) {
          return "Số lượng tối đa không được nhỏ hơn số lượng tối thiểu";
        }
      },
      quantityMin: (value, values) => {
        if (value && values.quantityMax && value > values.quantityMax) {
          return "Số lượng tối đa không được nhỏ hơn số lượng tối thiểu";
        }
      },
    },
  });

  const getProductGift = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmItemCategoryCombination/get-list?Skip=0&Take=50`
    );

    if (res && res.success) {
      const result = res.data;
      setDataGift(result);
    }
  };

  useEffect(() => {
    getProductGift();
  }, [searchGift]);

  return (
    <div>
      <Box
        component="form"
        onSubmit={form.onSubmit((e) => {
          editItemDiscount({
            ...e,
            // attribute2:
            //   dataViewGift.length > 0
            //     ? dataViewGift.map((item) => item.itemCode).join(",")
            //     : null,
          });
        })}
      >
        <Grid mt="md">
          <Grid.Col span={4}>
            <NumberInput
              label={"Số Lượng tối thiểu"}
              placeholder={"Nhập số lượng"}
              hideControls
              {...form.getInputProps("quantityMin")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <NumberInput
              label={"Số Lượng tối đa"}
              placeholder={"Nhập số lượng"}
              hideControls
              {...form.getInputProps("quantityMax")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label={"Số Lượng áp dụng"}
              placeholder={"Nhập số lượng"}
              type="number"
              {...form.getInputProps("quantityApply")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Menu trigger="hover">
              <Menu.Target>
                <TextInput
                  label="Quà tặng tương đương"
                  placeholder="Nhập sản phẩm tương đương"
                  defaultValue={searchGift}
                  onChange={(e) => setSearchGift(e.currentTarget.value)}
                />
              </Menu.Target>
              <Menu.Dropdown>
                <ScrollArea
                  h={400}
                  onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                >
                  <Table striped highlightOnHover mt={10}>
                    <Table.Thead
                      className={cx(classes.header, {
                        [classes.scrolled]: scrolled,
                      })}
                    >
                      <Table.Tr>
                        <Table.Th>Mã sản phẩm</Table.Th>
                        <Table.Th>Tên sản phẩm</Table.Th>
                        <Table.Th>Thao tác</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {dataGift && dataGift.length > 0 ? (
                        dataGift.map((item, index) => (
                          <Table.Tr key={index}>
                            <Table.Td w={100}>{item.itemCode}</Table.Td>
                            <Table.Td w={475}>{item.itemName}</Table.Td>
                            <Table.Td w={85}>
                              <Button
                                variant="outline"
                                onClick={() =>
                                  setDataViewGift((prev) => [...prev, item])
                                }
                                disabled={
                                  dataViewGift.filter(
                                    (i) => i.itemCode === item.itemCode
                                  ).length > 0
                                }
                              >
                                {dataViewGift.filter(
                                  (i) => i.itemCode === item.itemCode
                                ).length > 0
                                  ? "Đã chọn"
                                  : "Chọn"}
                              </Button>
                            </Table.Td>
                          </Table.Tr>
                        ))
                      ) : (
                        <Table.Tr>
                          <Table.Td rowSpan={3} ta={"center"}>
                            {searchGift.length === 0
                              ? "Nhập ít nhất 3 kí tự để tìm kiếm !"
                              : "Không tìm thấy sản phẩm !"}
                          </Table.Td>
                        </Table.Tr>
                      )}
                    </Table.Tbody>
                  </Table>
                </ScrollArea>
              </Menu.Dropdown>
            </Menu>
          </Grid.Col>
          <Grid.Col span={12}>
            <ScrollArea
              h={400}
              onScrollPositionChange={({ y }) => setScrolledView(y !== 0)}
            >
              <Table striped highlightOnHover>
                <Table.Thead
                  className={cx(classes.header, {
                    [classes.scrolled]: scrolledView,
                  })}
                >
                  <Table.Tr>
                    <Table.Th>Mã sản phẩm</Table.Th>
                    <Table.Th>Tên sản phẩm</Table.Th>
                    <Table.Th>Thao tác</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {dataViewGift && dataViewGift.length > 0 ? (
                    dataViewGift.map((item, index) => (
                      <Table.Tr key={index}>
                        <Table.Td w={100}>{item.itemCode}</Table.Td>
                        <Table.Td w={375}>{item.itemName}</Table.Td>
                        <Table.Td w={55}>
                          <Button
                            variant="outline"
                            color="red"
                            onClick={() => {
                              const dataDelete = dataViewGift.filter(
                                (i) => i.itemCode !== item.itemCode
                              );

                              setDataViewGift(dataDelete);
                            }}
                          >
                            Xóa
                          </Button>
                        </Table.Td>
                      </Table.Tr>
                    ))
                  ) : (
                    <Table.Tr>
                      <Table.Td colSpan={3} ta={"center"} fw={500} h={350}>
                        Bạn chưa chọn quà tặng tương đương nào !
                      </Table.Td>
                    </Table.Tr>
                  )}
                </Table.Tbody>
              </Table>
            </ScrollArea>
          </Grid.Col>
        </Grid>

        {/* <Grid mt="md">
            <Grid.Col span={12}>
              <Textarea
                label={"Lưu ý thêm"}
                placeholder={"Nhập Lưu ý thêm"}
                autosize
                minRows={4}
                {...form.getInputProps("attribute1")}
              />
            </Grid.Col>
          </Grid> */}

        <Group justify="end" mt="md">
          <Button
            type="button"
            color="gray"
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={<IconWindow size={18} />}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </div>
  );
};

export default ModalItemGiftEditDiscount;
